import React, { useMemo } from "react";
import { useContent } from "../context/ContentContext";
import Header from "../components/Header";
import HomeHeroVideo from "../components/HomeHeroVideo";
import HeroSplit from "../components/HeroSplit";
import DualCards from "../components/DualCards";
import BrandsMarquee from "../components/BrandsMarquee";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsAppButton";

export default function Home() {
  const { content, loading } = useContent();

  // Inyectamos hrefs en los features de las tarjetas
  const cardsWithLinks = useMemo(() => {
    if (!content) return null;
    const musicHrefs = ["/music/audio-branding", "/music/produccion-artistica", "/music/series-cine-tv"];
    return {
      music: {
        ...content.cards.music,
        features: content.cards.music.features.map((f, i) => ({ ...f, href: musicHrefs[i] || "/music" })),
      },
      teams: {
        ...content.cards.teams,
        features: content.cards.teams.features.map((f) => ({ ...f, href: "/teams" })),
      },
    };
  }, [content]);

  if (loading || !content) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center text-white/60 font-mono-caps tracking-widest">
        CARGANDO...
      </div>
    );
  }

  return (
    <div className="relative min-h-screen bg-black text-white overflow-x-hidden">
      <Header />
      <HomeHeroVideo />

      {/* ELIGE TU UNIVERSO — banner grande */}
      <section className="relative bg-black pt-8 md:pt-12 pb-8 md:pb-12 px-6">
        <div className="max-w-7xl mx-auto text-center">
          <p className="font-mono-caps text-xs tracking-[0.35em] uppercase text-white/40 mb-6 md:mb-8">— El estudio —</p>
          <h2
            data-testid="elige-tu-universo-heading"
            className="font-display font-black leading-[0.95] text-[44px] sm:text-7xl md:text-8xl lg:text-[132px] xl:text-[164px] tracking-tight"
            style={{ wordBreak: "keep-all", overflowWrap: "normal" }}
          >
            <span className="text-white">Elige tu </span>
            <span className="bg-gradient-to-r from-[#ffb46b] via-[#ff8a3c] to-[#ff6a2b] bg-clip-text text-transparent">universo</span>
          </h2>
        </div>
      </section>

      {/* Mainscreen actual (HeroSplit) — inmediatamente debajo del heading */}
      <HeroSplit hero={content.hero} />

      {/* Tarjetas Music / Teams con features clicables */}
      <DualCards cards={cardsWithLinks} />

      {/* Marquee de marcas (viene de content.brands en DB) */}
      <BrandsMarquee brands={content.brands} />

      <Footer footer={content.footer} />
      <WhatsAppButton />
    </div>
  );
}
